import api from '../../utils/helpers/api'

type ResponType = {
  data: any
  meta: object
}
const uriJob = 'company-job'
const uriJobHash = 'company-job-list-hash'
const jobApply = 'job-apply'
const approveCompanyjob = 'approval'
const jobMultipleDelete = 'company-job-multiple-delete'

const job = {
  getJob: async (q: any) => {
    return await api.get(uriJob, {params: q})
  },
  approveCompanyJob: async (data: any) => {
    return (await api.post(`${approveCompanyjob}`, data)) as Promise<ResponType>
  },
  getJobHash: async (q: any) => {
    return await api.get(uriJobHash, {params: q})
  },
  showJob: async (id: any) => {
    return await api.get(uriJob + `/${id}`)
  },
  createOrUpdate: async (data: object, id?: any) => {
    let uri
    if (id) {
      uri = uriJob + '/' + id
    }
    return (await api[id ? 'put' : 'post'](`${id ? uri : uriJob}`, data)) as Promise<ResponType>
  },
  jobApply: async (q: any) => {
    return await api.get(jobApply, {params: q})
  },
  jobApplyHash: async (q: any) => {
    return await api.get(`${jobApply}-list-hash`, {params: q})
  },
  jobApplyPost: async (data: any) => {
    return await api.post(jobApply, data)
  },
  myJobApplicant: async (id: any, q: any) => {
    return await api.get(`${uriJob}/${id}/user`, {params: q})
  },
  myJobApplicantExport: async (id: any) => {
    return await api.get(`${uriJob}/${id}/user-export`)
  },
  updateApplicantStatus: async (param: any) => {
    return (await api.patch(`job-apply-status/${param.id}`, param)) as Promise<ResponType>
  },
  closeJob: async (param: any) => {
    return (await api.put(`company-job-status/${param.id}`, param)) as Promise<ResponType>
  },
  multipleDeleteJob: async (data: any) => {
    return (await api.post(`${jobMultipleDelete}`, data)) as Promise<ResponType>
  },
}

export default job
